import { lazy } from 'react';
import { UserTypes } from '@/configs/AppConfig';
import { MOD_SDG } from '@/configs/ModulesConfig';
import { Navigate } from "react-router-dom";

const SDGList = lazy(() => import('./SDGList'));


const route = [
    {
        path: MOD_SDG.base_path,
        element: <Navigate to={MOD_SDG.routes.list} replace />,
        auth: MOD_SDG.auth
    },
    {
        path: MOD_SDG.routes.list,
        element: <SDGList />,
        auth: MOD_SDG.auth
    },
];



export default route;